import { useState, useEffect, startTransition } from 'react';

/**
 * Hook dla bezpiecznego state podczas hydracji
 * Opóźnia aktualizacje state do zakończenia hydracji
 */
export const useHydrationSafeState = (initialValue) => {
    const [state, setState] = useState(initialValue);
    const [isHydrated, setIsHydrated] = useState(false);
    
    useEffect(() => {
        // Czekamy na zakończenie hydracji
        if (typeof window !== 'undefined') {
            const checkHydration = () => {
                if (!window.__IS_HYDRATING) {
                    setIsHydrated(true);
                } else {
                    setTimeout(checkHydration, 10);
                }
            };
            checkHydration();
        }
    }, []);
    
    const safeSetState = (newState) => {
        if (isHydrated || typeof window === 'undefined') {
            // Normalny setState po hydratacji lub na serwerze
            setState(newState);
        } else {
            // Opóźnione setState podczas hydracji
            startTransition(() => {
                setState(newState);
            });
        }
    };
    
    return [state, safeSetState];
};

export default useHydrationSafeState;